/**
 * Switches the sub category listing between the image grid and the compact list.
 *
 * Both layouts use the same markup and are separated in css, so this only moves a class
 * on the list. Grid is rendered as the active layout server side.
 */
const GRID_CLASS = 'link-block__links--grid';
const LIST_CLASS = 'link-block__links--list';
const CURRENT_CLASS = 'link-block__segmented-button--current';

document.querySelectorAll('[data-link-block-layout]').forEach((layout) => {
  const buttons = layout.querySelectorAll('[data-link-block-layout-value]');
  const links = layout
    .closest('.link-block')
    ?.querySelector('[data-link-block-links]');

  if (!links) {
    return;
  }

  layout.addEventListener('click', (event) => {
    const button = event.target.closest('[data-link-block-layout-value]');

    if (!button) {
      return;
    }

    const isList = button.dataset.linkBlockLayoutValue === 'list';

    links.classList.toggle(LIST_CLASS, isList);
    links.classList.toggle(GRID_CLASS, !isList);

    buttons.forEach((item) =>
      item.classList.toggle(CURRENT_CLASS, item === button)
    );
  });
});
